import React, { useEffect, useState } from "react";

import { useForm } from "../useForm";

import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { Checkbox } from "primereact/checkbox";
import Input from "../../controls/Input";
import SelectMenu from "../../controls/SelectMenu";
import ButtonSpinner from "../../controls/ButtonSpinner";
import { classNames } from "../../../shared/utility";

const initialFValues = {
  reason_selected: { value: -1 },
  weight_in_kg: 0,
  piece_count: 0,
  new_net_amount_kg: 0,
  new_tare_amount_kg: 0,
  new_gross_amount_kg: 0,
  new_amount_pieces: 0,
  full_return: true,
};

export default function RemoveWipItemByIdForm(props) {
  const {
    wip,
    item,
    onRemoveItemWipByBarcode,
    removeReasonFromWipOptions,
    setEmptyModelOpen,
  } = props;

  console.log("wip", wip);
  console.log("item", item);

  useEffect(() => {
    setValues({
      ...values,
      plu: item.plu,
      lot_number: item.lot_number,
      barcode: item.barcode,
      manufactured_product_id: item.manufactured_product_id,
      weight_in_kg: item.weight_in_kg,
      piece_count: item.piece_count,
      amount_to_remove_in_kg: item.weight_in_kg,
      new_amount_pieces: item.piece_count,
      product_name: item.product_name,
      stock_unit_of_measurement: item.stock_unit_of_measurement,
      parent_unique_id: item.parent_unique_id,
      warehouse_location_id: item.warehouse_location_id,
      new_net_amount_kg: item.total_weight_in_kg,
      new_tare_amount_kg: item.total_weight_in_kg,
      new_gross_amount_kg: item.total_weight_in_lbs,
      new_amount_pieces: item.total_pieces,
    });
  }, [item]);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("reason_selected" in fieldValues) {
      temp.reason_selected = null;
      if (fieldValues.reason_selected.value === -1) {
        temp.reason_selected = "This field is required.";
      }
    }

    if ("new_net_amount_kg" in fieldValues) {
      temp.new_net_amount_kg = null;
      if (
        fieldValues.new_net_amount_kg < 1 &&
        values.stock_unit_of_measurement !== 3
      ) {
        temp.new_net_amount_kg = "This field is required.";
      }

      if (fieldValues.new_net_amount_kg > parseFloat(values.weight_in_kg)) {
        temp.new_net_amount_kg = "Please check the weight again.";
      }
    }

    if (
      "new_amount_pieces" in fieldValues &&
      values.stock_unit_of_measurement === 3
    ) {
      temp.new_amount_pieces = null;
      if (fieldValues.new_amount_pieces < 1) {
        temp.new_amount_pieces = "This field is required.";
      }

      if (fieldValues.new_amount_pieces > values.piece_count) {
        temp.new_amount_pieces = "Please check the piece count again.";
      }
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false,
    validate
  );

  const onHandleSubmit = () => {
    if (validate()) {
      onRemoveItemWipByBarcode({
        wip_id: wip.id,
        barcode: item.barcode,
        reason_selected: values.reason_selected,
        new_net_amount_kg: values.new_net_amount_kg,
        new_tare_amount_kg: values.new_tare_amount_kg,
        new_gross_amount_kg: values.new_gross_amount_kg,
        new_amount_pieces: values.new_amount_pieces,
        full_return: values.full_return
      });
    }
  };

  return (
    <form>
      <div>
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
          <ExclamationCircleIcon
            className="h-11 w-11 text-red-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-start sm:mt-5">
          <p
            as="h3"
            className="text-center text-base font-normal leading-6 text-gray-800 family-didact"
          >
            Return item from WIP
          </p>
          <div className="mt-2">
            <p>
              {values.product_name} - {values.plu}
            </p>
            <p>{values.lot_number}</p>
          </div>
          <div className="mt-2 space-y-4 grid grid-cols-2 gap-4">
            <SelectMenu
              handleInputChange={handleInputChange}
              name="reason_selected"
              options={removeReasonFromWipOptions}
              value={values.reason_selected}
              title={"Reason"}
              parentClass="col-span-2"
              error={errors.reason_selected}
            />

            <div className="col-span-2 flex items-center gap-2">
              <Checkbox
                inputId="full_return"
                name="full_return"
                checked={values.full_return || false}
                onChange={(e) => {
                  handleInputChange({
                    target: {
                      name: "full_return",
                      value: e.checked,
                    },
                  });
                }}
              />
              <label htmlFor="full_return" className="text-sm text-gray-700">
                Full Return
              </label>
            </div>

            {!values.full_return && (
              <>
                <Input
                  label="Net Amount (kg)"
                  name="new_net_amount_kg"
                  onChange={handleInputChange}
                  value={values.new_net_amount_kg}
                  labelOn={true}
                  type="number"
                  className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
                  error={errors.new_net_amount_kg}
                />

                <Input
                  label="Tare (kg)"
                  name="new_tare_amount_kg"
                  onChange={handleInputChange}
                  value={values.new_tare_amount_kg}
                  labelOn={true}
                  type="number"
                  className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
                  error={errors.new_tare_amount_kg}
                />

                <Input
                  label="Gross (kg)"
                  name="new_gross_amount_kg"
                  onChange={handleInputChange}
                  value={values.new_gross_amount_kg}
                  labelOn={true}
                  type="number"
                  className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
                  error={errors.new_gross_amount_kg}
                />

                <Input
                  label="Pieces"
                  name="new_amount_pieces"
                  onChange={handleInputChange}
                  value={values.new_amount_pieces}
                  labelOn={true}
                  type="number"
                  parentClass={classNames(
                    item.stock_unit_of_measurement === 3 ? null : "hidden"
                  )}
                  className={
                    "block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
                  }
                  error={errors.new_amount_pieces}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center gap-3">
        <button
          type="button"
          className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
          onClick={() =>
            setEmptyModelOpen({ childComponent: null, open: false })
          }
        >
          Cancel
        </button>
        <button
          type="button"
          className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={onHandleSubmit}
        >
          <ButtonSpinner spin={false} text="OK" />
        </button>
      </div>
    </form>
  );
}
